var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"event"},[(
      _vm.isEventSubexponent &&
        !_vm.isEventSubexponentViewedByOrganizer &&
        !_vm.event.is_edit
    )?_c('EventSubexponentReaderMessage'):_vm._e(),_c('EventHeader'),_c('div',{staticClass:"event__content"},[_c(_vm.determineParticipant,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }